import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';

import { NotFoundComponent } from './notFound/notFound.component';
import { AuthGuard } from './guard/auth.guard';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
    },
    {
        path: 'home',
        loadChildren: () => import('./modules/layout/layout.module').then(m => m.LayoutModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'profile',
        loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'master',
        loadChildren: () => import('./modules/master/master.module').then(m => m.MasterModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'operations',
        loadChildren: () => import('./modules/operations/operations.module').then(m => m.OperationsModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'corporate-client',
        loadChildren: () => import('./modules/corporate-client/corporate-client.module').then(m => m.CorporateClientModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'security',
        loadChildren: () => import('./modules/security/security.module').then(m => m.SecurityModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'box-office',
        loadChildren: () => import('./modules/box-office/box-office.module').then(m => m.BoxOfficeModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'reports',
        loadChildren: () => import('./modules/report/reports.module').then(m => m.ReportsModule),
        canActivate: [AuthGuard]
    },
    {
        path: '**',
        component: NotFoundComponent
    }
]

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
  
export class AppRoutingModule { }